export const MANUAL_APPROVAL_PENDING = 'MANUAL_APPROVAL_PENDING';
export const STAGE_PROMOTED = 'STAGE_PROMOTED';
